import { useState } from "react";

export interface RowSelectionState<TRow> {
	selectedRows: TRow[];
	onlySelectedRow: TRow | undefined;
	setSelectedRows: (rows: TRow[]) => void;
}

export const useRowSelection = <TRow>(): RowSelectionState<TRow> => {
	const [selectedRows, setSelectedRows] = useState<TRow[]>([]);
	const onlySelectedRow = selectedRows.length === 1 ? selectedRows[0] : undefined;

	return {
		selectedRows,
		onlySelectedRow,
		setSelectedRows,
	};
};
